import "@storefront-ui/shared/styles/global/_color.scss";

import "@storefront-ui/vue/src/utilities/transitions/_transitions.scss";
import "@storefront-ui/vue/src/utilities/animations/_animations.scss";

import "./assets/css/styles.scss";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Attente from "./layouts/Attente.vue";
import Blank from "./layouts/Blank.vue";
import Default from "./layouts/Default.vue";
import Product from "./layouts/Product.vue";
import Checkout from "./layouts/Checkout.vue";
import { i18n } from "vue-lang-router";
import VueI18n from "vue-i18n";

import "./utils/filters";

Vue.component("attente-layout", Attente);
Vue.component("blank-layout", Blank);
Vue.component("default-layout", Default);
Vue.component("checkout-layout", Checkout);
Vue.component("product-layout", Product);

Vue.config.productionTip = false;
Vue.use(VueI18n);
new Vue(
  {
    router,
    i18n,
    store,
    render: h => h(App),
  },
).$mount("#app");
